<template>
  <b-card class="mt-8">
    <template #header>
      <div class="d-flex">
        <div class="mr-auto py-2 d-flex">
          <b-button variant="info" class="px-5" @click.prevent="$emit('open-add-modal')">
            + Agregar instancia
          </b-button>
        </div>
      </div>
    </template>

    <b-card-text>
      <b-table
        responsive
        :fields="fields"
        :items="instances"
        striped
        hover
        outlined
        fixed
      >
        <template #cell(status)="row">
          <b-badge :variant="row.item.status ? 'success' : 'warning'">
            {{ row.item.status ? 'Verificada' : 'No verificada' }}
          </b-badge>
        </template>

        <template #cell(actions)="{ item }">
          <b-button size="sm" variant="primary" class="mr-2" @click.prevent="$emit('edit-instance', item)">
            Editar
          </b-button>
          <b-button size="sm" variant="danger" @click.prevent="confirmDelete(item)">
            Eliminar
          </b-button>
        </template>
      </b-table>

      <template v-if="instances.length === 0">
        <b-alert show variant="info" class="mt-3">
          No hay instancias configuradas aún.
        </b-alert>
      </template>
    </b-card-text>
  </b-card>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'OdooInstanceTable',
  props: {
    instances: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        { key: 'type', label: 'Tipo', sortable: true, formatter: this.formatType },
        { key: 'url', label: 'URL', sortable: true },
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'db_name', label: 'Base de datos', sortable: true },
        { key: 'username', label: 'Usuario', sortable: false },
        { key: 'status', label: 'Estado', sortable: true },
        { key: 'last_checked_at', label: 'Última validación', sortable: true },
        { key: 'actions', label: 'Acciones' }
      ]
    };
  },
  methods: {
    ...mapMutations(['setLoading']),
    confirmDelete(instance) {
      this.$swal({
        title: '¿Eliminar instancia?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.deleteInstance(instance);
        }
      });
    },
    async deleteInstance(instance) {
      this.setLoading(true);
      try {
        const res = await this.$conectar.post(`odoo-client-instance/delete/${instance.id}`);
        if (res.data.success) {
          this.$emit('refresh-list');
          this.$swal({
            icon: 'success',
            title: 'Eliminado',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000
          });
        }
      } catch (e) {
        console.error(e.response || e);
      }
      this.setLoading(false);
    },
    formatType(value) {
      switch (value) {
        case 'production':
          return 'Producción'
        case 'testing':
          return 'Pruebas'
        default:
          return value
      }
    }
  }
};
</script>

<style scoped>
/* estilos si se necesitan */
</style>
